import styled from 'styled-components';

import { RootFieldIcons, RootFieldInput } from '../_shared/styled';

const FieldInput = styled(RootFieldInput)`
  padding: 16px 16px 16px 42px;
  padding-left: ${({ isAvatar, hideSearchIcon }) => {
    if (isAvatar) {
      return '62px';
    }
    if (hideSearchIcon) {
      return '16px';
    }
    return '42px';
  }};
`;

const FieldIcons = styled(RootFieldIcons)`
  left: 12px;
`;

const CategoryChipStyled = styled.div`
  position: absolute;
  top: 10px;
  left: ${({ textLength }) => 62 + textLength * 9}px;
  left: ${({ isAvatar, hideSearchIcon, textLength }) => {
    if (isAvatar) {
      return 62 + textLength * 9;
    }
    if (hideSearchIcon) {
      return 16 + textLength * 9;
    }
    return 42 + textLength * 9;
  }}px;

  padding: 0 4px;
  background-color: ${({ theme }) => theme.gray50};

  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  color: ${({ theme }) => theme.brand500};

  transition: 0.3s;
`;

export { FieldInput, FieldIcons, CategoryChipStyled };
